// src/components/SubmitTime/components/SubmitTimeSkeleton.tsx
// Shimmer skeleton shown while the Submit Time modal initializes

import React from 'react';

interface SkeletonRowProps {
  inputHeight?: number;
}

const SkeletonRow: React.FC<SkeletonRowProps> = ({ inputHeight = 32 }) => (
  <div className="submit-time-skeleton-row">
    <div className="submit-time-skeleton-label">
      <div className="st-skeleton-pulse" style={{ height: 12, width: '55%', borderRadius: 2 }} />
    </div>
    <div className="submit-time-skeleton-input">
      <div className="st-skeleton-pulse" style={{ height: inputHeight, borderRadius: 2 }} />
    </div>
  </div>
);

export const SubmitTimeSkeleton: React.FC = () => (
  <div className="submit-time-skeleton">
    {/* Layer selector */}
    <SkeletonRow />
    {/* Date */}
    <SkeletonRow />
    {/* Hours */}
    <SkeletonRow />
    {/* Remaining */}
    <SkeletonRow />
    {/* Custom field rows */}
    <SkeletonRow />
    <SkeletonRow />
    {/* Reply editor */}
    <div style={{ marginTop: 10 }}>
      <div className="st-skeleton-pulse" style={{ height: 150, borderRadius: 2 }} />
    </div>
  </div>
);

export default SubmitTimeSkeleton;
